import { Component, Input, OnInit } from '@angular/core';
import { ChartConfigService } from 'src/app/utils/chart/chart-config.service';
import { DriverScore } from '../../activity-vehicle-classification.component';
import { ActivityVehiculeClassificationsService } from '../../activity-vehicule-classifications.service';
const Highcharts = require('highcharts');
require('highcharts/modules/exporting')(Highcharts);

@Component({
  selector: 'app-classification-result-chart',
  templateUrl: './classification-result-chart.component.html',
  styleUrls: ['./classification-result-chart.component.css']
})
export class ClassificationResultChartComponent implements OnInit {


  classments: DriverScore[] = [];
  classmentObject: Object | null = null;

  @Input()
  set driverScores(driverScores: DriverScore[]) {
    if (driverScores) {
      this.classments = Object.assign(driverScores);
      this.fuelingChart();
    }
  }
  constructor(private chartConfig: ChartConfigService,
    private classificationService:ActivityVehiculeClassificationsService
  ) { }

  ngOnInit() {
    this.fuelingChart();
  }

  fuelingChart() {
    this.chartConfig.setHighCartsLang();
    var data:{ name: string, y: number,color:string ,avatarUri?: string}[] = [];
    this.classments.filter(dScore => dScore.driver).forEach(dScore => {
      data.push({
        name: dScore.driver,
        y: dScore.score / 10,
        color:this.classificationService.getColorFromName(dScore.driver),
        avatarUri: dScore.avatarUri
        });
    });

    this.classmentObject = {
      chart: {
        type: 'column'
      },
      title: {
        text: 'Classification',
        style: {
          fontWeight: 'bold'
        }
      },
      credits: {
        enabled: false
      },
      xAxis: {
        type: 'category',

        labels: {
          rotation: -45,
          style: {
            color: "#000000",
            fontWeight: 'bold',
            textDecoration: "underline"
          }
        }
      },
      yAxis: {
        title: {
          text: 'Note'
        },
        labels: {
          enabled: false
        }
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        column: {
          borderRadius: 5,
        },
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: false,
            useHTML: false
          }
        }
      },
      tooltip: {
        useHTML: true,
        formatter: function(this: any): string {
          const avatar = this.point.avatarUri ? this.point.avatarUri : '';
          return `
            <div style="display:flex; align-items:center;">
              <img src="${avatar}" style="width:40px; height:40px; border-radius:50%; margin-right:5px;" />
              <div>
                <b>${this.point.name}</b><br/>
                Note: ${this.point.y.toFixed(2)}/20
              </div>
            </div>
          `;
        }
      },
      series: [
        {
          data: data,
          colorByPoint: true
        }
      ]
    }
    Highcharts.chart('resultClassmentObject', this.classmentObject);
  }

}
